import { Component } from '@theme/component';

/**
 * A custom element that manages a page popup.
 */
export class PagePopupTriggerComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', (event) => {
      if (!this.dataset.handle) return;

      event.preventDefault();
      event.stopPropagation();
      document.dispatchEvent(
        new CustomEvent('page-popup:toggle', {
          detail: {
            handle: this.dataset.handle,
            insurancePopupContentTemplate: this.refs.insurancePopupContentTemplate,
          },
        }),
      );
    });
  }
}

if (!customElements.get('page-popup-trigger-component'))
  customElements.define('page-popup-trigger-component', PagePopupTriggerComponent);
